import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface BubbleMenuButtonProps {
  onClick: () => void;
  active?: boolean;
  children: React.ReactNode;
  "aria-label": string;
  style?: React.CSSProperties;
}

export function BubbleMenuButton({
  onClick,
  active,
  children,
  "aria-label": ariaLabel,
  style,
}: BubbleMenuButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className={cn("relative h-7 w-7 p-0", active && "bg-accent")}
      onClick={onClick}
      aria-label={ariaLabel}
      style={style}
    >
      {children}
    </Button>
  );
}
